import React, { useState } from 'react'
import GameManager from '../../../../../GameManager';
import Tools from '../../../../../Misc/Tools';
import { JSXUIData, JSXUIDebugTemplate } from '../../../../../UI/JsxUiManager';
import { UI } from '../../../../../UI/UiManager';
import { VideoSegmentItem, SingleVideoSegmentItem } from '../../../../../VideoSegment/VideoSegmentItem';
import { VideoSegmentManager } from '../../../../../VideoSegment/VideoSegmentManager';
import VideoEnvironment from '../../../../Environments/React/VideoEnvironment';
import CoreGeneralButton from '../../core-general-button';

import "./core-debug-video-segments-window.css"

const CoreDebugVideoSegmentsWindow = (props: CoreDebugVideoSegmentsWindowConfig) => {
	return (
		<div className='core-debug-ui-video-segment-window core-debug-ui-general-window'>
				<div className='core-debug-ui-back-bttn'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						onClick= {props.onBackToMainWindowClicked}
						onRenderContent= {() => {
							return (
								<p className='center-element'>{'Back to Main Window'}</p>
							)
						}}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Back to Main Window'}></CoreGeneralButton>
				</div>

				<div className='core-debug-ui-general-window' style={{width: '900px', height: '900px', 'overflow': 'auto'}}>
					{props.videoSegmentManager.items.map((item: VideoSegmentItem, videoSegmentItemIndx: number) => {
						return (
							<div key={Tools.generateGuid()} style={{
								marginTop: '10px'
							}}>

								<CoreGeneralButton width= '100%'
									height= '50px'
									onClick= {() => {
										item._isExpanded = !item._isExpanded;
										props.setForceUpdate();
									}}
									onRenderContent= {() => {
										return (
											<p className='center-element'>{item.title}</p>
										)
									}}
									isSelected= {false}
									isDisabled={false}
									ariaLabel= {item.title}></CoreGeneralButton>

								{item._isExpanded ? (
									<div style={{
										position: 'relative',
										height: '50px',
										marginTop: '10px'
									}}>
										{/* {item.getItems().map((videoSegment: SingleVideoSegmentItem, videoSegmentIndx: number) => {
											return videoSegment.chapterIds.map((chapterId: string, chapterIdIndx: number) => {
												return (
													<div key={Tools.generateGuid()} style={{
														width: '50%',
														position: 'relative',
														height: '50px',
														left: '10%'
													}}>
														<CoreGeneralButton width= '100%'
															height= '50px'
															style={{backgroundColor: 'rgba(255,255,255,0.7'}}
															onClick= {() => {
																const demoScenario = props.gameManager.scenarios[0];
																demoScenario.loadAllVideosInEnvironment({
																	partId: '',
																	url: [videoSegment.src],
																}, () => {
																	props.onVideoSegmentPlaying();
																	demoScenario.playVideoChapter('', chapterId, () => {
																		props.onVideoSegmentStopped();
																		(props.gameManager.environment as VideoEnvironment).pauseCurrentSequence();
																	}, false);
																});
																props.onVideoSegmentStarted();
															}}
															onRenderContent= {() => {
																return (
																	<p className='center-element'>{chapterId}</p>
																)
															}}
															isSelected= {false}
															isDisabled={false}
															ariaLabel= {chapterId}></CoreGeneralButton>
													</div>
												);
											})
											
										})} */}
									</div>
								) : (null)}
							</div>
							
						);
					})}
				</div>
			</div>
	);
};

export interface CoreDebugVideoSegmentsWindowConfig {
	showWindowBackground: boolean;
	videoSegmentManager: VideoSegmentManager;
	gameManager: GameManager;
	onBackToMainWindowClicked: () => void;
	onVideoSegmentStarted: () => void;
	onVideoSegmentPlaying: () => void;
	onVideoSegmentStopped: () => void;
	setForceUpdate: () => void;
}

export default CoreDebugVideoSegmentsWindow;